import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import DotIcon from '../../../components/DotIcon';
import Tooltip from '../../../../muiComponents/Tooltip';
import Tag from '../../../../muiComponents/Tag';
import { categorizePeriod, formatDate } from '../../../../utils/formatDates';
import routes from '../../../../utils/commonVariables/routes';
import { TAX_DATE_TAG_COLOR } from '../../../../utils/taxes/taxesListUtils';
import {
    IContractListState,
    RATE_SCOPE_MODEL_KEY_ICON,
} from '../../../../types/contracts/contractTypes';
import Status from '../../../../components/Status';
import { RATE_SCOPE_MODEL_KEY_TAG_COLOR } from '../../../../utils/contractUtils/contractUtils';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import { useHistory } from 'react-router-dom';
import encodeBase64 from '../../../../utils/encodeBase64';
import Icon from '../../../../muiComponents/Icon';

interface ContractRowProps {
    contract: IContractListState;
}

const ContractRow = ({ contract }: ContractRowProps) => {
    const history = useHistory();

    const handleRowClick = (id: string) => {
        const currentPath = history.location.pathname;
        history.push(`${currentPath}/${encodeBase64(id)}`);
    };

    const tagText = categorizePeriod(contract.ActiveFrom, contract.ActiveTo);
    const linkToHotel = routes.propertyDetail(contract.IdSupplierHotel);

    const rateScopeIconName =
        RATE_SCOPE_MODEL_KEY_ICON[
            contract.RateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON
        ];
    const rateScopeTagColor =
        RATE_SCOPE_MODEL_KEY_TAG_COLOR[
            contract.RateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_TAG_COLOR
        ];

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(contract.Id)}
        >
            <TableCell>
                <div className='flex-center'>
                    <DotIcon truthy={contract.Enabled} />
                </div>
            </TableCell>
            <TableCell>
                <Status
                    text={contract.StaticRateContractStatusType}
                    color={contract.StaticRateContractStatusColor}
                />
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <div className='flex-column gap-20'>
                    <div>
                        <h6 className='text-secondary-700 text-size-14'>
                            {contract.Name}
                        </h6>
                        <Tooltip title={contract.Description || ''}>
                            <p className='tax__description text-preline'>
                                {contract.Description || ''}
                            </p>
                        </Tooltip>
                    </div>
                    <Tooltip titleText='rate_plan' placement='top-start'>
                        <div className='flex gap-5'>
                            <Icon iconName={commonIcons.RATE_PLAN} />
                            <p>{contract.SupplierHotelRatePlan}</p>
                        </div>
                    </Tooltip>
                </div>
            </TableCell>

            <TableCell style={{ minWidth: 200 }}>
                <Tooltip titleText='navigate_to_hotel_detail'>
                    <h6
                        className='tax__title link-onhover'
                        onClick={e => {
                            e.stopPropagation();
                            window.open(linkToHotel, linkToHotel);
                        }}
                    >
                        {contract.SupplierHotel}
                    </h6>
                </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>{contract.Agency}</TableCell>

            <TableCell>
                <div className='flex flex-center'>
                    <Tooltip titleText='rate_scope_model'>
                        <span>
                            <Tag
                                color={rateScopeTagColor}
                                text={contract.RateScopeModel}
                                startIcon={rateScopeIconName}
                            />
                        </span>
                    </Tooltip>
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <div className='flex-column flex-align-end gap-10 height100perc flex-between'>
                    {formatDate(contract.ActiveFrom)} -{' '}
                    {formatDate(contract.ActiveTo)}
                    <Tag text={tagText} color={TAX_DATE_TAG_COLOR[tagText]} />
                </div>
            </TableCell>
        </TableRow>
    );
};

export default ContractRow;
